import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useStyles } from './styled';

const Layout = ({
  header, line1, line2, line3
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography variant="h4">{header}</Typography>
      <Typography variant="h4">{line1}</Typography>
      <Typography variant="h2">{line2}</Typography>
      <Typography variant="h4">{line3}</Typography>
    </div>
  );
};

Layout.propTypes = {
  header: PropTypes.string,
  line1: PropTypes.string,
  line2: PropTypes.string,
  line3: PropTypes.string,
};

Layout.defaultProps = {
  header: '',
  line1: '',
  line2: '',
  line3: '',
};

export default Layout;
